export const doughnutTextPlugin = {
    id: 'doughnutTextPlugin',
    beforeDraw(chart) {
        if (chart.config.type !== 'doughnut') {
            return;
        }

        const { width, height } = chart.chartArea;
        const { ctx } = chart;
        const centerText = chart.options.plugins.doughnutTextPlugin?.text || '';
        if (!centerText) {
            return;
        }

        const centerX = width / 2;
        const centerY = height / 2;

        ctx.save();
        ctx.font = '32px Arial'; // Change font and size as desired
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';

        ctx.fillText(centerText, centerX, centerY);
        ctx.restore();
    }
}
